export * from './lib/environment.module';
export { environment, isMock, isProd } from './lib/config/convict';
